import { render, staticRenderFns } from "./BasicDashboard.vue?vue&type=template&id=63f201a0&"
import script from "./BasicDashboard.vue?vue&type=script&lang=js&"
export * from "./BasicDashboard.vue?vue&type=script&lang=js&"
import style0 from "./BasicDashboard.vue?vue&type=style&index=0&id=63f201a0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports